// ─── Generic Email Composer ──────────────────────────────────────────────────
//
// A domain-agnostic email compose payload. Any feature that needs to send an
// ad-hoc email (vendors, clients, contacts, …) can reuse the same backend
// endpoint (`POST /messaging/emails`) and the frontend `ComposeEmailModal`.
// ─── File-Upload Requests (public, tokenized) ────────────────────────────────
//
// A tokenized "please send us files" link, for a vendor, a client or anybody
// the office names, about any record (Phase 9 / COMMUNICATIONS-DESIGN E). The
// recipient opens `/upload/:token` (no login; `/vendor-upload/:token`, the
// address older emails carry, is the same page) and sends up to
// `MAX_UPLOAD_FILES` files at once. Every file lands in the library, on the
// record; the producer who asked hears through the `upload.received`
// notification, and the sender is emailed a confirmation.
/** How many files one upload link takes, in its one submission. */
export const MAX_UPLOAD_FILES = 20;
/**
 * The records a producer may ask files about. An event's own files; a vendor
 * on an event (its booking row); an expense line; an item; a venue; a vendor.
 */
export const UPLOAD_REQUEST_TARGET_TYPES = [
    'EVENT',
    'ENTITY_LINK',
    'EXPENSE',
    'PLANNING_ITEM',
    'VENUE',
    'VENDOR',
];
//# sourceMappingURL=messaging.js.map